/* eslint-disable import/prefer-default-export */
export var TERRITORIES_KEYS = {
  ID: 'orchId',
  NAME: 'territoryName',
  CONTINENT: 'continent'
};